import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "4ef36a63-30ed-4917-a13d-286877377e62", content: "Higher at lower frequencies.", options: {} },
  { id: "622ae083-6468-40bb-8dba-bc17a7a99e97", content: "Same at low and at high frequencies.", options: {} },
  { id: "8cc81be4-5060-4e16-9e2c-b8ac398aa725", content: "Lower at lower frequencies.", options: {} },
  { id: "f8f677e4-2251-4aaf-abe1-a17294c562b8", content: "It can not be determined.", options: {} },
];

export const task: Task = {
  id: "9e5d8a52-d445-4132-a94b-560ea68a5b37",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["8cc81be4-5060-4e16-9e2c-b8ac398aa725"],
};
